<template>
  <v-container class="pa-0 ma-0" fluid>
    <v-card elevation="0" min-width="100%">
      <common-data-table
        :headers="headers"
        collectionName="categories"
        ref="editTable"
      >
        <template v-slot:newItemPopup="{ close, item, formKey }">
          <common-editing-popup
            ref="editPopup"
            :title="item ? 'Edit category' : 'Create a new category'"
            :saveBtnTitle="item ? 'Save category' : 'Create category'"
            collectionName="categories"
            :loading="addingCategory"
            :originalItem="item"
            :canSubmit="formValid"
            @close="editingFinished($event, close)"
            :key="'category-edit-' + (item ? item.id : formKey)"
          >
            <template v-slot:default="{ editedItem }">
              <v-form v-model="formValid" ref="form">
                <v-text-field
                  filled
                  required
                  label="Name"
                  v-model="editedItem.name"
                  :rules="[rules.required]"
                ></v-text-field>
              </v-form>
            </template>
          </common-editing-popup>
        </template>
      </common-data-table>
    </v-card>
  </v-container>
</template>

<script>
import CommonDataTable from '@/components/CommonDataTable.vue'
import CommonEditingPopup from '@/components/CommonEditingPopup.vue'
import { mapGetters, mapActions } from 'vuex'
import { db } from '@/firebaseConfig'
import { textFieldRules } from '@/common'

export default {
  name: 'CategorySettings',
  components: {
    CommonDataTable,
    CommonEditingPopup,
  },
  data() {
    return {
      formValid: false,
      addingCategory: false,
      headers: [
        {
          text: 'Name',
          value: 'name',
        },
        {
          text: 'Edit',
          value: 'actions',
          sortable: false,
        },
      ],
      items: [],
      listeners: [],
      loading: false,
      editingCategory: null,
      rules: textFieldRules,
    }
  },
  mounted() {
    this.loadData()
  },
  beforeDestroy() {
    // Unsubscribe from firestore listeners
    for (const idx in this.listeners) {
      this.listeners[idx]()
    }
    this.listeners = []
  },
  computed: {
    ...mapGetters(['companyId', 'newTableItemPopupVisible']),
    path() {
      return `companies/${this.companyId}/categories`
    },
  },
  methods: {
    ...mapActions(['hideNewTableItemPopup', 'showNewTableItemPopup']),
    editingFinished(cancelled, close) {
      if (!cancelled) {
        this.$store.dispatch('getInventoryCategories', true)
      }
      close()
    },
    async loadData() {
      this.loading = true

      let listener = db
        .collection(this.path)
        .orderBy('name')
        .onSnapshot(
          (snapshot) => {
            const result = snapshot.docs.map((doc) => {
              return {
                id: doc.id,
                ...doc.data(),
              }
            })
            this.items = result
            this.loading = false
          },
          (error) => {
            console.error(error)
            this.loading = false
          }
        )

      this.listeners.push(listener)
    },
    closeCategoryAddPage() {
      this.editingCategory = null
      this.hideNewTableItemPopup()
    },
    editCategory(category) {
      this.editingCategory = category
      this.showNewTableItemPopup()
    },
  },
}
</script>
